import React from 'react'
import DashboardContentManagement from "../../../components/ContentManagementCard/DashboardContentManagement";
import { useNavigate } from 'react-router-dom';
import ammoun from "../../../assets/images/announ-icon.png";
import fame from "../../../assets/images/fame-icon.png";
import news from "../../../assets/images/news-icon.png";
import talks from "../../../assets/images/talk-icon.png";
import poll from "../../../assets/images/poll-icon.png";
import { useSelector } from 'react-redux';
function ContentManagement() {
   const { language, translations } = useSelector((state) => state.language);
  const navigate = useNavigate();
  const handleView = (id) => {
    if (id == 1) {
      navigate("/user/ViewHallOfFame");
    } else if (id == 2) {
      navigate("/user/ViewManagementTalk");
    } else if (id == 3) {
      navigate("/user/ViewNewsAndBlogs");
    } else if (id == 4) {
      navigate("/user/ViewAnnouncement");
    } else if (id == 5) {
      navigate("/user/ViewOpinionPoll");
    }
  }
  const handleAdd = (id) => {
    if (id == 1) {
      navigate("/user/AddHallOfFame");
    } else if (id == 2) {
      navigate("/user/AddManagementTalk");
    } else if (id == 3) {
      navigate("/user/AddNewsAndBlog");
    } else if (id == 4) {
      navigate("/user/AddAnouncement");
    } else if (id == 5) {
      navigate("/user/AddOpinionPoll");
    }
  }
  const cardsData = [
    { id: 1, title:translations.labels.hallOfFame, icon: fame },
    { id: 2, title: translations.labels.managementTalk, icon: talks },
    { id: 3, title: translations.labels.newsAndBlogs, icon: news },
    { id: 4, title: translations.labels.announcements, icon: ammoun },
    { id: 5, title: translations.labels.opinionPoll, icon: poll },
  ];
  return (
    <DashboardContentManagement
      handleAdd={handleAdd}
      handleView={handleView}
      cardsData={cardsData}
    />

  )
}

export default ContentManagement




